<script>
  import './style.css';

  import Footer from 'src/components/footer/footer.svelte';
  import Cookies from 'js-cookie';
  import Number from './Number.svelte';

  import roomStore from 'src/stores/Room';

  export let conn;

  document.body.classList.remove("bg-primary");

  let token = Cookies.get('token');
  $: token = Cookies.get('token');
  $: me = $roomStore.members.find(m => m.id == token );

  let numbers = [0, 1, 2, 3, 5, 8, 13, 21];

  const vote = (vote) => {
    if ($roomStore.showVotes) return;
    conn.send(JSON.stringify({
      action: 'vote',
      vote: vote
    }));
  };

  const showVotes = () => {
    conn.send(JSON.stringify({
      action: 'show-votes'
    }));
  };

  const clearVotes = () => {
    conn.send(JSON.stringify({
      action: 'clear-votes'
    }));
  };

  const toggleSpectator = () => {
    conn.send(JSON.stringify({
      action: 'toggle-spectator'
    }));
  };

  const kick = (id) => {
    conn.send(JSON.stringify({
      action: 'kick',
      token: id
    }));
  };
</script>

<main>
  <div class="container-fluid px-4">
    <h3 class="mt-4">Room Code: {$roomStore.id}</h3>
    <h4 class="mt-4">Vote</h4>
    <button type="button" class="btn btn-primary" on:click={() => toggleSpectator() }>Toggle Spectator</button>
    <div class="row mt-3">
      {#each numbers as number}
        {#if $roomStore.me.isSpectator}
          <Number number={number} />
        {:else}
          <div class="col-xl-1 col-md-3" on:click={() => vote(number)}>
            <div class="card {$roomStore.me.vote==number ? 'bg-info' : ''} mb-4">
              <div class="card-body text-center" style="cursor:pointer;">
                {number}
              </div>
            </div>
          </div>
        {/if}
      {/each}
    </div>
    <h4 class="mt-4">
      Members
    </h4>

    {#if token == $roomStore.ownerId}
      <button type="button" class="btn btn-primary" on:click={() => showVotes() }>Show Votes</button>
      <button type="button" class="btn btn-secondary" on:click={() => clearVotes() }>Clear Votes</button>
    {/if}

    <div class="row mt-3">
      {#each $roomStore.members as member}
        <div class="col-xl-1 col-md-3">
          <div class="card mb-4">
            <div class="card-header">{member.name}</div>
            <div class="card-body">
              {#if member.isSpectator}
                Spectating
              {:else if $roomStore.showVotes}
                {member.vote}
              {:else}
                {#if member.vote != null}
                  Voted
                {:else}
                  Waiting
                {/if}
              {/if}
            </div>
            <div class="card-footer">
              {#if $roomStore.ownerId == me.id && member.id != me.id}
                <button type="button" class="btn btn-sm btn-danger" on:click={() => kick(member.id) }>Kick</button>
              {/if}
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
</main>
<Footer />
